import { render, staticRenderFns } from "./video-cards.vue?vue&type=template&id=74e072a4&scoped=true&"
import script from "./video-cards.vue?vue&type=script&lang=js&"
export * from "./video-cards.vue?vue&type=script&lang=js&"
import style0 from "./video-cards.vue?vue&type=style&index=0&id=74e072a4&scoped=true&lang=css&"
import style1 from "./video-cards.vue?vue&type=style&index=1&id=74e072a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e072a4",
  null
  
)

export default component.exports